/**
 * chronology — anno di riferimento per l'ordinamento/collocazione cronologica.
 *
 * Gli autori senza `birth_year` (es. Beowulf, opera medievale senza data certa)
 * NON devono finire in fondo: pur essendo antichi, vanno collocati per epoca
 * tramite il primo `period`. Usato sia dall'ordinamento del catalogo
 * (StaticDataService) sia dalla timeline della mappa dei temi (ThemeMapView),
 * così l'ordine è coerente ovunque.
 */

import type { Author } from './schema';

/** Ancora d'epoca (anno medio) per autori privi di `birth_year`. */
export const PERIOD_ANCHOR: Record<string, number> = {
  'old-english-medieval': 1000,
  renaissance: 1550,
  'restoration-18c': 1700,
  colonial: 1700,
  romantic: 1800,
  'american-romanticism': 1840,
  victorian: 1860,
  'american-realism': 1880,
  modernist: 1910,
  contemporary: 1970,
};

/**
 * Anno per ordinare/collocare un autore: `birth_year` se noto, altrimenti
 * l'ancora del primo `period` (fallback 1500 se il period è sconosciuto).
 * `dated` indica se il valore è una data reale o un ripiego d'epoca.
 */
export function chronoYear(author: Author): { year: number; dated: boolean } {
  if (typeof author.birth_year === 'number') return { year: author.birth_year, dated: true };
  const anchor = author.periods[0] ? PERIOD_ANCHOR[author.periods[0]] : undefined;
  return { year: anchor ?? 1500, dated: false };
}
